/* ============================================================
   Flow Wake-Up Quiz — Analytics
   Exposes: window.trackEvent, window.UTM
   Fans events out to Shopify Customer Events and Klaviyo
   ============================================================ */

(function () {
  var FUNNEL = (window.__QUIZ_FUNNEL) || 'wakeup';
  var QUIZ_ID = 'wakeup';
  var QUIZ_VERSION_ID = 'flow_quiz_wakeup_v1';
  var PRODUCTION_HOSTS = {
    'flowalarmclock.com': true,
    'www.flowalarmclock.com': true
  };
  var SESSION_KEY = 'flow-quiz-' + FUNNEL + '-session';
  var EVENT_NAMES = {
    quiz_started: 'flow_quiz:started',
    step_viewed: 'flow_quiz:step_viewed',
    step_completed: 'flow_quiz:step_completed',
    question_answered: 'flow_quiz:answer_selected',
    quiz_completed: 'flow_quiz:offer_clicked',
    email_gate_submitted: 'flow_quiz:email_submitted',
    email_gate_skipped: 'flow_quiz:email_skipped',
    reveal_shown: 'flow_quiz:result_viewed',
    unlock_claimed: 'flow_quiz:reward_claimed',
    unlock_card_flipped: 'flow_quiz:reward_card_flipped',
    dock_showcase_view: 'flow_quiz:dock_showcase_view',
    dock_showcase_autoadvance: 'flow_quiz:dock_showcase_autoadvance'
  };

  // -------- session id (one per visit) --------
  function getSessionId() {
    var id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = 'qs-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  }

  // -------- UTM capture (sticky for this session) --------
  function readUTM() {
    var STORE = 'flow-quiz-' + FUNNEL + '-utm';
    var stored = sessionStorage.getItem(STORE);
    if (stored) {
      try { return JSON.parse(stored); } catch (e) { /* fallthrough */ }
    }
    var params = new URLSearchParams(window.location.search);
    var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ttclid'];
    var out = {};
    keys.forEach(function (k) {
      var v = params.get(k);
      if (v) out[k] = v;
    });
    sessionStorage.setItem(STORE, JSON.stringify(out));
    return out;
  }

  var UTM = readUTM();

  // -------- core dispatch --------
  function resolveEventName(eventName) {
    return EVENT_NAMES[eventName] || ('flow_quiz:' + String(eventName || 'unknown'));
  }

  function getAnalyticsEnv() {
    var host = window.location && window.location.hostname ? window.location.hostname : '';
    if (PRODUCTION_HOSTS[host]) return 'production';
    if (/^(localhost|127\.0\.0\.1|0\.0\.0\.0)$/i.test(host)) return 'development';
    return 'theme_preview';
  }

  function getQuizExperimentProps() {
    var experiments = window.FlowQuizExperiments;
    if (!experiments || typeof experiments.getLandingAnalyticsProps !== 'function') return {};

    try {
      return experiments.getLandingAnalyticsProps();
    } catch (e) {
      return {};
    }
  }

  function trackIntelligemsQuizEvent(eventName, properties) {
    var igEventName = null;

    if (eventName === 'quiz_started') {
      igEventName = 'flow_quiz_started';
    } else if (eventName === 'step_viewed' && properties && properties.step_type === 'landing') {
      igEventName = 'flow_quiz_landing_viewed';
    }

    if (!igEventName) return;

    try {
      window.igEvents = window.igEvents || [];
      window.igEvents.push({
        event: igEventName,
        properties: properties || {}
      });
    } catch (e) {
      /* swallow — analytics never breaks the funnel */
    }
  }

  function trackEvent(eventName, props) {
    var resolvedName = resolveEventName(eventName);
    var analyticsEnv = getAnalyticsEnv();
    var enriched = Object.assign(
      {
        funnel: FUNNEL,
        quiz_id: QUIZ_ID,
        quiz_version_id: QUIZ_VERSION_ID,
        analytics_env: analyticsEnv,
        is_development: analyticsEnv !== 'production',
        session_id: getSessionId(),
        ts: Date.now(),
        path: window.location.pathname
      },
      UTM,
      getQuizExperimentProps(),
      props || {}
    );

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try { window.Shopify.analytics.publish(resolvedName, enriched); }
      catch (e) { /* swallow — analytics never breaks the funnel */ }
    }

    // Klaviyo (if present on the page — usually only on LP via Shopify integration)
    if (window._learnq && Array.isArray(window._learnq)) {
      try { window._learnq.push(['track', resolvedName, enriched]); }
      catch (e) { /* swallow */ }
    }

    // Always log to console in dev — easy to spot when something breaks
    if (window.__QUIZ_DEBUG) {
      // eslint-disable-next-line no-console
      console.log('[quiz]', resolvedName, enriched);
    }

    trackIntelligemsQuizEvent(eventName, enriched);
  }

  window.trackEvent = trackEvent;
  window.UTM = UTM;
  window.FLOW_QUIZ_ANALYTICS = {
    quizId: QUIZ_ID,
    quizVersionId: QUIZ_VERSION_ID,
    getSessionId: getSessionId,
    eventNames: EVENT_NAMES
  };
})();
